import React from 'react';
import PropTypes from 'prop-types';
import { isString } from 'lodash';
import cn from 'classnames';
import ErrorMessage from 'shared/components/ErrorMessage';
import styles from './Select.module.scss';

const Select = ({
  value,
  label,
  options,
  error,
  emptyValue,
  emptyValueLabel,
  optGroupsBy,
  fullWidth,
  inline,
  children,
  size,
  ...props
}) => {
  const id = props.id || `${props.name || 'select'}-${Math.round(Math.random() * 10000)}`;

  const renderOptions = opts => opts.map(option => (
    <option value={option.value} key={option.value} disabled={option.disabled === true}>{option.label}</option>
  ));

  const renderOptgroups = (optGroups, key) => optGroups.map(optGroup => (
    <optgroup key={optGroup.value} label={optGroup.label} disabled={optGroup.disabled === true}>
      {renderOptions(optGroup[key])}
    </optgroup>
  ));

  return (
    <div className={cn(styles.select, { [styles.fullWidth]: fullWidth, [styles.inline]: inline, [styles.small]: size === 'small' })}>
      {label !== null && (
        <label htmlFor={id} className={error ? `${styles.error} error` : ''}>{label}</label>
      )}

      <select id={id} value={value !== null ? value : emptyValue} className={error ? `${styles.error} error` : ''} {...props}>
        {emptyValueLabel !== null && <option value={emptyValue}>{emptyValueLabel}</option>}
        {optGroupsBy !== null ? renderOptgroups(options, optGroupsBy) : renderOptions(options)}
      </select>
      {children}
      {isString(error) && <ErrorMessage>{error}</ErrorMessage>}
    </div>
  );
};

Select.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    disabled: PropTypes.bool,
    [PropTypes.string]: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      disabled: PropTypes.bool,
    }))
  })),
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  emptyValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  emptyValueLabel: PropTypes.string,
  optGroupsBy: PropTypes.string,
  fullWidth: PropTypes.bool,
  inline: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'normal'])
};

Select.defaultProps = {
  value: null,
  label: null,
  options: [],
  error: null,
  emptyValue: '',
  emptyValueLabel: null,
  optGroupsBy: null,
  fullWidth: false,
  inline: false,
  size: 'normal'
};

export default Select;
